import { ReusableDataTable } from '@operations/shared';
import moment from 'moment';
import { useDispatch } from 'react-redux'
import { stepperMoving,setUnidentifiedCollectionID } from '../../stores/actions';

export default function AllUnidentifiedCollection() {
    const dispatch = useDispatch()

    const getCollectionInfo = (collectionInfo: any) => {
        dispatch(setUnidentifiedCollectionID(collectionInfo))
        dispatch(stepperMoving(1));
    }
    const collectionId: any = {
        title: 'Collection ID',
        dataIndex: 'id',
        render: (_: any, collectionInfo: any) => (
            <div>
                <span
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => { getCollectionInfo(collectionInfo) }}
                > {collectionInfo?.id}</span>

            </div>
        ),
    };
    let columns = [
        {
            title: 'Collection Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Collection Date',
            dataIndex: 'collectionDate',
            key: 'collectionDate',
            render: (row: any) => moment(row).format('LL')
        },
        {
            title: 'Reference number',
            dataIndex: 'referenceNumber',
            key: 'referenceNumber',
            
        },
    ];
    columns = [collectionId, ...columns];
    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <ReusableDataTable columns={columns} hiddenRefreshing
                    apiLink={`/invoices/unidentifiedDeposits`}
                    pagination={false} loading={false} scrolling={{ x: 100, y: 300 }} loadData={true}/>
            </div>
        </>
    )
}
